// extracted by mini-css-extract-plugin
export var icon = "_5b-3";
export var subtitle = "_5b-2";
export var title = "_5b-1";
export var value = "_5b-0";